export const shouldShowKeyboardActivationGuide = ({
  isNative,
  isKeyboardActive,
  isDesktop,
  isMacApp
}) => isNative && !isKeyboardActive && !isDesktop && !isMacApp
